import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../../components/common/PrimaryButton";
import Modal from "../../../../components/common/Modal";

export interface Props {
  type: "Total Transferred" | "Pending Transfer" | "Open Balance" | "";
  onClose: () => void;
}

const WalletModal: React.FC<Props> = ({
  type,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const { title, icon, content } = useMemo(() => {
    let title = "";
    let icon = "";
    let content = "";
    switch (type) {
      case "Total Transferred":
        title = t("lbl_total_transferred_balance_modal_title");
        icon = "assets/images/svg/altMoney.svg";
        content = t("lbl_total_transferred_balance_modal_subtitle");
        break;
      case "Open Balance":
        title = t("balance_number_card_open_title");
        icon = "assets/images/svg/blue_clock.svg";
        content = t("lbl_total_opened_balance_modal_subtitle");
        break;
      case "Pending Transfer":
      default:
        title = t("balance_number_card_processing_title");
        icon = "assets/images/svg/inprocess.svg";
        content = t("lbl_total_processing_balance_modal_subtitle");
        break;
    }

    return { title, icon, content };
  }, [t, type]);

  const handleCancel = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  return (
    <Modal
      visible={type !== ""}
      onCancel={handleCancel}
      size="small"
      customModalContainerClassName={styles["custom_container"]}>
      <div className={styles["modal_container"]}>
        <div className={styles["icon_cont"]}>
          <img src={icon} className={styles["icon"]} alt="wallet" />
        </div>
        <div className={styles["text_cont"]}>
          <h1>{title}</h1>
          <p>{content}</p>
        </div>

        <PrimaryButton
          id={`wallet_modal_close_button`}
          buttonType={PrimaryButtonType.PRIMARY_LIGHT}
          onClick={handleCancel}>
          <p className={styles["close_button"]}>{t("creation_back_button")}</p>
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default WalletModal;
